export default "__VITE_ASSET__C2MXhtMC__"